import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { TICKET_PAGE_URL } from '@/api/core/links';
import { type Ticket } from '../core/_models';
import { dueWeekdayLabel } from '../core/_utils';

type Props = {
  ticket: Ticket;
  onClose: () => void;
};

const TicketOpenedModal = ({ ticket, onClose }: Props) => {
  const navigate = useNavigate();
  const title = `Chamado #${ticket.number} aberto`;
  const dueLabel = dueWeekdayLabel(ticket.dueAt);
  const deadline = `${ticket.path.department} responde até ${dueLabel}.`;

  const followTicket = () => {
    const ticketPageUrl = TICKET_PAGE_URL(ticket.id);
    onClose();
    navigate(ticketPageUrl);
  };

  return (
    <Modal centered show aria-labelledby="ticket-opened-title" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title id="ticket-opened-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex align-items-start gap-4">
        <i className="ki-duotone ki-check-circle fs-2x text-success">
          <span className="path1" />
          <span className="path2" />
        </i>
        <div className="d-flex flex-column gap-1">
          <span className="text-gray-900 fw-bold fs-6">{ticket.title}</span>
          <span className="text-gray-700 fs-7">{deadline}</span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          Fechar
        </Button>
        <Button variant="primary" onClick={followTicket}>
          Acompanhar chamado
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketOpenedModal;
